import React, { useState } from "react";
import { useSearchParams } from "react-router-dom";
import Quiz from "../components/Quiz";

const QuizPage = () => {
  const [searchParams] = useSearchParams();
  const tema = searchParams.get("tema");
  const isEcologia = tema === "ecologia";

  const [progress, setProgress] = useState(0);

  const updateProgress = (currentQuestion, totalQuestions) => {
    if (totalQuestions > 0) {
      setProgress(((currentQuestion + 1) / totalQuestions) * 100);
    }
  };

  const pageStyle = {
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    minHeight: "100vh",
    backgroundImage: `linear-gradient(rgba(0,0,0,0.3), rgba(0,0,0,0.5)), url(${
        process.env.PUBLIC_URL +
        (tema === "ecologia" ? "/assets/ecopic.jpg" : "/assets/7.jpg")
      })`,
    backgroundSize: "cover",
    backgroundPosition: "center",
    position: "relative",
    overflow: "hidden",
  };

  const overlayStyle = {
    position: "absolute",
    top: 0,
    left: 0,
    width: "100%",
    height: "100%",
    backgroundColor: "rgba(0, 0, 0, 0.6)",
    zIndex: 0,
  };

  const containerStyle = {
    position: "relative",
    padding: "25px 20px",
    borderRadius: "15px",
    boxShadow: "0px 8px 20px rgba(0, 0, 0, 0.9)",
    textAlign: "center",
    width: "100%",
    maxWidth: "600px",
    backgroundColor: "rgba(255, 255, 255, 0.3)",
    height: "calc(100vh - 40px)",
    display: "flex",
    flexDirection: "column",
    justifyContent: "flex-start",
    gap: "10px",
    zIndex: 1,
    overflowY: "auto",
  };

  const titleStyle = {
    color: "black",
    fontSize: "2.3rem",
    fontWeight: "bold",
    marginBottom: "0px",
    wordBreak: "break-word",
    textShadow: "0 0 10px rgba(255, 105, 180, 0.7), 0 0 20px rgb(248, 7, 7)",
  };

  const progressBarContainerStyle = {
    width: "100%",
    backgroundColor: "#ddd",
    borderRadius: "10px",
    overflow: "hidden",
    height: "10px",
  };

  const progressBarStyle = {
    height: "100%",
    width: `${progress}%`,
    backgroundColor: "#4caf50",
    transition: "width 0.5s ease-in-out",
  };

  return (
    <div style={pageStyle}>
      <div style={overlayStyle}></div>
      <div style={containerStyle}>
        <h1 style={titleStyle}>
          {isEcologia ? "EcoKaringana" : "Karingana"}
        </h1>

        <div style={progressBarContainerStyle}>
          <div style={progressBarStyle}></div>
        </div>

        <Quiz updateProgress={updateProgress} />
      </div>
    </div>
  );
};

export default QuizPage;
